import React, { Fragment } from "react";
import Slider from "react-slick";
import TitleSliderItem from "../../components/titlebar-slider-item/titlebar-slider-item";

const TitlesSlider = (props) => {
  var settings = {
    lazyLoad: "ondemand",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !1,
    dots: !1,
    fade: !0,
    infinite: !0,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1e3,
    //className: "navbarWidgetMobWrapper",
    pauseOnFocus: false,
    pauseOnHover: false,
    //slidesToShow: 5,
    //focusOnSelect: false,
    //adaptiveHeight: true,
    //variableWidth: true
    // draggable:true,
    //centerMode: true,
    //initialSlide: 5,
  };
  let element = null;
  props.titleSliderDataArr !== undefined
    ? (element = (
        <Slider {...settings}>
          {props.titleSliderDataArr.map((slideInfo) => {
            return (
              <TitleSliderItem
                key={slideInfo.id}
                description={slideInfo.longDescription}
                collapsedDrawerTextColor={props.collapsedDrawerTextColor}
              />
            );
          })}
        </Slider>
      ))
    : (element = null);
  return <Fragment>
    {element}
    </Fragment>;
};

export default React.memo(TitlesSlider);
